import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const firstThree = categories.slice(0, 7);
const lastSeven = categories.slice(7);

export default function DeepSeoSection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="flex-1 flex flex-col justify-center">
            <div className="max-w-xl">
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight mb-6">
                Why GTBuy Spreadsheet Is the Smart Choice for Sourcing Professionals
              </h2>

              <div className="space-y-5 text-foreground-700 text-sm md:text-base leading-relaxed">
                <p>
                  In the rapidly evolving world of e-commerce and global sourcing, having the right
                  spreadsheet automation system can make the difference between scaling efficiently
                  and drowning in manual data entry. GTBuy Spreadsheet has emerged as a leading
                  solution for buying agents who need reliable, fast, and flexible workflow
                  management tools.
                </p>
                <p>
                  Unlike traditional spreadsheet tools that require constant manual updates and
                  formula tweaking, GTBuy Spreadsheet is <strong>built for scalable spreadsheet automation</strong>. It
                  reduces manual tracking errors by structuring workflows intelligently, allowing
                  sourcing professionals to focus on what matters most — growing their business and
                  serving their clients.
                </p>
                <p>
                  When compared to alternatives like Kakobuy Spreadsheet and Superbuy Spreadsheet,
                  GTBuy consistently delivers <strong>faster data handling</strong> and more
                  <strong> flexible integration options</strong>. Whether you are managing e-commerce
                  order tracking, product sourcing management, or cross-platform spreadsheet sync,
                  GTBuy provides the comprehensive toolset modern buying agents require.
                </p>
              </div>

              <Link
                to="/what-is-gtbuy-spreadsheet"
                className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-full bg-accent-500 text-foreground-950 text-sm font-semibold hover:bg-accent-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                Read Full SEO Guide
                <i className="ri-arrow-right-line"></i>
              </Link>

              <div className="flex gap-10 md:gap-16 mt-12">
                <div>
                  <p className="font-heading text-4xl md:text-5xl font-bold text-foreground-950">
                    14+
                  </p>
                  <p className="text-xs text-foreground-500 mt-1">Product Categories</p>
                </div>
                <div>
                  <p className="font-heading text-4xl md:text-5xl font-bold text-foreground-950">
                    100%
                  </p>
                  <p className="text-xs text-foreground-500 mt-1">Automation Ready</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/5] lg:aspect-auto lg:h-[600px]">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20editorial%20photography%20of%20modern%20workspace%20with%20laptop%20displaying%20spreadsheet%20interface%2C%20clean%20cream%20desk%20surface%20with%20warm%20natural%20lighting%2C%20beige%20and%20sand%20color%20palette%2C%20elegant%20professional%20atmosphere%2C%20soft%20shadows%2C%20coffee%20cup%20beside%20keyboard%2C%20plants%20in%20background%2C%20modern%20home%20office%20aesthetic%2C%20harmonious%20composition&width=800&height=1000&seq=deep-seo-image-001&orientation=portrait"
                alt="GTBuy Spreadsheet workspace setup"
                title="GTBuy Spreadsheet - Automation System for Buying Agents"
                className="w-full h-full object-cover"
              />
              <div className="absolute top-4 left-4">
                <span className="px-4 py-1.5 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-900 text-xs font-medium">
                  GTBuy Ecosystem
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent p-6">
                <p className="text-background-50 text-sm font-medium">
                  Streamline Your Sourcing Workflow
                </p>
                <p className="text-background-50/70 text-xs mt-1">
                  Built for high-volume operations
                </p>
              </div>
            </div>

            <div className="mt-6 grid grid-cols-2 gap-3">
              <div className="bg-background-100 rounded-2xl p-4">
                <p className="text-xs text-foreground-500 mb-1">Speed</p>
                <p className="font-heading text-xl font-bold text-foreground-950">
                  Faster than Kakobuy
                </p>
              </div>
              <div className="bg-background-100 rounded-2xl p-4">
                <p className="text-xs text-foreground-500 mb-1">Flexibility</p>
                <p className="font-heading text-xl font-bold text-foreground-950">
                  More than Superbuy
                </p>
              </div>
            </div>

            <div className="mt-4">
              <div className="flex flex-wrap gap-2">
                {firstThree.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="px-3 py-1.5 rounded-full bg-background-100 text-foreground-600 text-xs hover:bg-background-200 hover:text-foreground-950 transition-all duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
              <div className="flex flex-wrap gap-2 mt-2">
                {lastSeven.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="px-3 py-1.5 rounded-full bg-background-100 text-foreground-600 text-xs hover:bg-background-200 hover:text-foreground-950 transition-all duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}